import { ActionTypeEnum } from './cartDetails/actionType.model';
import { ICartDetails } from '../interfaces/cart-details.interface';
import { MainProcessTypeEnum } from './cartDetails/main-process-type.enum';

export class HeaderModel {

  public title: string;
  public msisdn: string;
  public description: string;
  public actionType: ActionTypeEnum;
  public mainProcessType: MainProcessTypeEnum;

  constructor(cartDetails: ICartDetails) {
    if (cartDetails && cartDetails.headerData) {
      this.msisdn = cartDetails.headerData.msisdn;
      this.title = cartDetails.headerData.title;
      this.description = cartDetails.headerData.description;
      this.mainProcessType = cartDetails.mainOfferProcessType;
      this.actionType = cartDetails.commonProcessData.actionType;
    }
  }

  public showAddNumberSuccess(): boolean {
    return this.mainProcessType && this.mainProcessType === MainProcessTypeEnum.RETENTION && this.actionType === ActionTypeEnum.VOUCHER;
  }

  public showDescription(): boolean {
    return this.actionType && this.actionType !== ActionTypeEnum.VOUCHER && !!this.description;
  }

}
